import { render } from "./ProviderCard.vue?vue&type=template&id=181b4b74&scoped=true"
import script from "./ProviderCard.vue?vue&type=script&lang=js"
export * from "./ProviderCard.vue?vue&type=script&lang=js"

import "./ProviderCard.vue?vue&type=style&index=0&id=181b4b74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181b4b74"]])

export default __exports__